module.exports = __webpack_public_path__ + "static/img/kols11.bd18782.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/kols/kols11.png
// module id = Y736
// module chunks = 0